<template>
  <TipsVue
    v-if="mini && item.tips && !active"
    :keyTips="item.tips"
    content-class="zarbo-tips__home-page tooltip-right__home-page"
  >
    <v-list-item link class="left-menu__item" :class="{ 'left-menu__item--active': active }" v-bind="$attrs">
      <template #prepend>
        <v-icon
          size="24"
          :color="active ? 'rgb(var(--v-theme-primary))' : '#A09BCC'"
          :icon="item.icon"
          class="ma-0 mr-3"
        />
      </template>
      <v-list-item-title class="left-menu__item-title">{{ item.title }}</v-list-item-title>
    </v-list-item>
  </TipsVue>
  <v-list-item
    v-else
    link
    class="left-menu__item"
    :class="{ 'left-menu__item--active': active }"
    v-bind="$attrs"
  >
    <template #prepend>
      <v-icon
        size="24"
        :color="active ? 'rgb(var(--v-theme-primary))' : '#A09BCC'"
        :icon="item.icon"
        class="ma-0 mr-3"
      />
    </template>
    <v-list-item-title class="left-menu__item-title">{{ item.title }}</v-list-item-title>
    <template v-slot:append>
      <v-icon
        v-show="active"
        size="8"
        attach
        color="white"
        icon="menuPisulka"
        class="ma-0 mr-3"
        :style="{ position: 'fixed', right: mini ? '-2px' : '-14px', opacity: 1 }"
      />
    </template>
  </v-list-item>
</template>

<script>
import TipsVue from "@/components/Utils/TipsVue.vue";

export default {
  name: "left-menu-item",
  components: { TipsVue },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
